export enum TypeAssociation {
  PROFESSIONALS = 'PR',
  POLITICIANS = 'PL',
  COMMERCIAL = 'C',
  BUSINESS = 'N',
  OTHER = 'O'
}

export const TYPE_ASSOCIATION = {
  PROFESSIONALS: 'PR',
  POLITICIANS: 'PL',
  COMMERCIAL: 'C',
  BUSINESS: 'N',
  OTHER: 'O'
}

export const NAME_ASSOCIATION = {
  PR: 'Profesionales',
  PL: 'Políticos',
  C: 'Comerciales',
  N: 'Negocios',
  O: 'Otro'
}

export const CATALOG_REASONS_ASSOCIATION = [
  { value: TYPE_ASSOCIATION.PROFESSIONALS, label: NAME_ASSOCIATION.PR },
  { value: TYPE_ASSOCIATION.POLITICIANS, label: NAME_ASSOCIATION.PL },
  { value: TYPE_ASSOCIATION.COMMERCIAL, label: NAME_ASSOCIATION.C },
  { value: TYPE_ASSOCIATION.BUSINESS, label: NAME_ASSOCIATION.N },
  { value: TYPE_ASSOCIATION.OTHER, label: NAME_ASSOCIATION.O }
]
